import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../component/img/logo3.jpg"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { Menu, ChevronDown,Headphones, PhoneCall, User, Monitor, Send, DollarSign, } from "react-feather";
import NavbarVisitorTwo from "../pages/Visitors/VisitorComp/NavbarVisitorTwo";

const Navbar = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false); // State to manage dropdown

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen); // Function to toggle the dropdown

  return (
    <>
      <section className="bg-white sticky-top hedshdw">
        <nav className="navbar navbar-expand-lg navbar-light">
          <div className="container d-flex justify-content-between align-items-center" style={{ width: "100%" }}>
            {/* Logo */}
            <Link className="navbar-brand" to="/">
              <img src={logo} className="img-fluid logo" alt="Logo" />
              <div className="olap2">TOPAIRVIEW SOLUTIONS PVT. LTD.</div>
            </Link>

            {/* Hamburger Button */}
            <button
              className="btn1 btn-outline-secondary d-lg-none ms-auto"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasMenu"
              aria-controls="offcanvasMenu"
            >
              <FontAwesomeIcon icon={faBars} />
            </button>

            {/* Desktop Navbar Links */}
            <div className="collapse navbar-collapse d-none d-lg-flex" id="navbarNav">
              <ul className="navbar-nav ms-auto">
                <li className="nav-item">
                  <Link className="nav-link" to="/">
                    <span className="listnew spntxt1"> 
                    {" "}Home</span>
                  </Link>
                </li>

                <li className="nav-item">
                  <Link className="nav-link" to="/all-package">
                    <span className="listnew spntxt1"> 
                    {" "}All Packages</span>
                  </Link>
                </li>

                
 

 
 
                <li className="nav-item">
                  <Link className="nav-link" to="/contact">
                    <span className="listnew spntxt1">Contact Us</span>
                  </Link>
                </li>

                 

                {/* Login or Signup */}
                <li className="nav-item">
                  <Link className="nav-link" to="/login">
                    <span className="listnew spntxt2 loginbtn text-white">Login</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        {/* Off-Canvas Menu for Mobile */}
        <div
          className="offcanvas offcanvas-end"
          tabIndex="-1"
          id="offcanvasMenu"
          aria-labelledby="offcanvasMenuLabel"
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasMenuLabel">
              Menu
            </h5>
            <button
              type="button"
              className="btn-close text-reset ms-auto"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  <span className="listnew">
                  <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000"><path d="M264-216h96v-240h240v240h96v-348L480-726 264-564v348Zm-72 72v-456l288-216 288 216v456H528v-240h-96v240H192Zm288-327Z"/></svg>
                  Home</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  <span className="listnew">
                  <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000"><path d="m401-130-95-176-176-95 67-68 145 25 97-96-309-133 85-85 372 69 120-120q21-21 51-21t51 21q21 21 21 50.5T809-708L689-588l69 373-85 85-133-309-96 97 25 145-68 67Z"/></svg>
                  Flight</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  <span className="listnew"><svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#000000"><path d="M48-192v-576h72v384h312v-336h336q60 0 102 42t42 102v384h-72v-120H120v120H48Zm228-240q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35Zm228 48h336v-192q0-29.7-21.15-50.85Q797.7-648 768-648H504v264ZM276-504q20.4 0 34.2-13.8Q324-531.6 324-552q0-20.4-13.8-34.2Q296.4-600 276-600q-20.4 0-34.2 13.8Q228-572.4 228-552q0 20.4 13.8 34.2Q255.6-504 276-504Zm0-51Zm228-93v264-264Z"/></svg>
                  Hotel</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  <span className="listnew">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#000000"><path d="M240-200q-50 0-85-35t-35-85H40v-360q0-33 23.5-56.5T120-760h560l240 240v200h-80q0 50-35 85t-85 35q-50 0-85-35t-35-85H360q0 50-35 85t-85 35Zm360-360h160L640-680h-40v120Zm-240 0h160v-120H360v120Zm-240 0h160v-120H120v120Zm120 290q21 0 35.5-14.5T290-320q0-21-14.5-35.5T240-370q-21 0-35.5 14.5T190-320q0 21 14.5 35.5T240-270Zm480 0q21 0 35.5-14.5T770-320q0-21-14.5-35.5T720-370q-21 0-35.5 14.5T670-320q0 21 14.5 35.5T720-270ZM120-400h32q17-18 39-29t49-11q27 0 49 11t39 29h304q17-18 39-29t49-11q27 0 49 11t39 29h32v-80H120v80Zm720-80H120h720Z"/></svg>
                  Bus</span>
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  <span className="listnew">About Us</span>
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/contact">
                  <span className="listnew">Contact Us</span>
                </Link>
              </li>
              
              {/* <li className="nav-item">
                <Link className="nav-link" to="/login">
                  <span className="listnew loginbtn">Login</span>
                </Link>
              </li> */}
            </ul>
          </div>
        </div>
      </section>

      <NavbarVisitorTwo/>
    </>
  );
};

export default Navbar;
